import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import Editor from './Editor';

function PdfConfiguration({ templates }) {
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    navigate('/resume'); // ✅ Always go back to resume
  }, [navigate]);

  return <Editor onClose={handleClose} templates={templates} />;
}

PdfConfiguration.propTypes = {
  templates: PropTypes.object.isRequired
};

export default PdfConfiguration;
